module.exports = __webpack_public_path__ + "img/Dao.79a9cc67.png";